// stores/websiteConfigurationStore.js

import { defineStore } from 'pinia';
import { ref, toRaw } from 'vue';

export const useWebsiteConfigurationStore = defineStore('websiteConfiguration', {
  state: () => ({
    configuration: null,
  }),
  actions: {
    getRaw(key) {
      return toRaw(this.configuration[key]);
    },
    setWebsiteConfiguration(configuration) {
      this.configuration = configuration;
    },
  },
});
